/* =====================================================================
   MASSBLATT · GEFÜHRTE FOLGE (MB + RS, Vorschau T1) · 25.09.2026
   Aus der Maßkarte (serverseitig, ohne Skript voll bedienbar) wird eine geführte Folge:
   Bestellung → Vorbereitung → zehn Maße (je ein Schritt) → Ergänzungen → Überblick → Senden.
   Regeln: Enter führt weiter und sendet NIE · Browser-Zurück = ein Schritt (history.pushState) ·
   Entwurf nur in sessionStorage dieses Tabs, nach dem Senden gelöscht · keine Personendaten in URL/localStorage ·
   gesendet wird einmal an /contact mit denselben Datenschlüsseln contact[…] (Stufe 1) ·
   RS: Einheit cm·kg / in·lb, das Atelier erhält IMMER cm (Originalwerte zusätzlich im Feld „Units / Original“) ·
   Plausibilität nur als Hinweis, nie als Sperre (Grenzen vorläufig, Abnahme Atelier).
   3D-Maßbüste: erst auf Knopfdruck, three.js selbst gehostet (assets/mbf-massbueste.js, IIFE, global mbfBueste), ohne WebGL bleibt Bild + Text.
   ===================================================================== */
(function () {
  'use strict';
  var wurzel = document.getElementById('mbf');
  var datenEl = document.getElementById('mbf-daten');
  if (!wurzel || !datenEl) return;
  var D; try { D = JSON.parse(datenEl.textContent); } catch (x) { return; }
  var DE = D.sprache !== 'en';
  var RS_EINHEITEN = !!D.einheiten;
  var SKEY = 'mbf:' + location.pathname, BKEY = 'mbf-beleg:' + location.pathname;
  var $ = function (id) { return document.getElementById(id); };
  var scrolle = function (y, relativ) { var z = relativ ? window.scrollY + y : y; try { window.scrollTo({ top: Math.max(0, z), left: 0, behavior: 'instant' }); } catch (x) { window.scrollTo(0, Math.max(0, z)); } };
  var alle = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var sLesen = function (k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (x) { return null; } };
  var sSchreiben = function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); return true; } catch (x) { return false; } };
  var sLoeschen = function (k) { try { sessionStorage.removeItem(k); } catch (x) {} };

  var T = DE ? {
    schritt: function (n, m) { return 'Schritt <strong>' + n + '</strong> von ' + m; },
    masse: function (n, m) { return n + ' von ' + m + ' Maßen'; },
    massU: function (i, n) { return 'Maß ' + i + ' von ' + n; },
    karte: 'Alle Maße auf einen Blick', gefuehrt: 'Schritt für Schritt',
    inEinheit: { cm: 'in Zentimetern', in: 'in Zoll' }, gewichtIn: { cm: 'in Kilogramm', in: 'in Pfund' },
    beispiel: { cm: 'Zum Beispiel 104 oder 104,5.', in: 'Zum Beispiel 41 oder 41,25.' },
    leer: function (akk) { return 'Bitte tragen Sie ' + akk + ' ein.'; },
    nurZahl: 'Bitte nur die Zahl eintragen.', meter: function (cm) { return 'In Zentimetern sind das ' + cm + ' cm.'; },
    uebernehmen: function (w) { return w + ' übernehmen'; },
    plausLaenge: 'Im Verhältnis zur Körpergröße ungewöhnlich. Bitte noch einmal nachmessen – stimmt die Zahl, lassen Sie sie so.',
    plausBreite: 'Im Verhältnis zum Brustumfang ungewöhnlich. Bitte noch einmal nachmessen – stimmt die Zahl, lassen Sie sie so.',
    zollVerdacht: 'Gemessen in Zoll? Dann in der Vorbereitung auf „in · lb“ umstellen.',
    fehlerliste: function (n) { return n === 1 ? 'Eine Angabe fehlt noch' : n + ' Angaben fehlen noch'; },
    vorbefuellt: 'Aus Ihrer Bestellbestätigung übernommen.', nochNicht: 'Dann ordnen wir Ihre Maße über Ihre E-Mail-Adresse zu.',
    bestellnrEntfaellt: 'Bestellnummer (entfällt)', bestellnrLeer: 'Bitte tragen Sie Ihre Bestellnummer ein – oder wählen Sie „Ich habe noch nicht bestellt.“',
    pruefen: 'bitte prüfen', aendern: 'ändern', strich: '—',
    entwurf: 'Entwurf in diesem Tab gesichert.', entwurfZurueck: 'Ihr Entwurf aus diesem Tab ist wieder da.', verwerfen: 'Entwurf verwerfen',
    robe: function (n) { return 'Ihre Robe: ' + n; },
    laden: 'Die Büste wird geladen …', keinWebgl: 'Die 3D-Büste ist auf diesem Gerät nicht verfügbar – Bild und Text zeigen jedes Maß.',
    formName: { damen: 'Damenform', herren: 'Herrenform' },
    buesteAria: function (f, nr, titel, text) { return 'Drehbare ' + f + ' mit Maßband, ' + nr + ' ' + titel + ': ' + text; },
    filmAlt: function (titel, text) { return 'Standbild aus dem Maßnehmen-Film: ' + titel + '. ' + text; },
    gewicht: 'Körpergewicht', original: function (u) { return u === 'in' ? 'in · lb (Originalwerte)' : 'cm · kg'; }
  } : {
    schritt: function (n, m) { return 'Step <strong>' + n + '</strong> of ' + m; },
    masse: function (n, m) { return n + ' of ' + m + ' measurements'; },
    massU: function (i, n) { return 'Measurement ' + i + ' of ' + n; },
    karte: 'All measurements at a glance', gefuehrt: 'Step by step',
    inEinheit: { cm: 'in centimeters', in: 'in inches' }, gewichtIn: { cm: 'in kilograms', in: 'in pounds' },
    beispiel: { cm: 'For example 104 or 104.5.', in: 'For example 41 or 41.25.' },
    leer: function (akk) { return 'Please enter your ' + akk + '.'; },
    nurZahl: 'Please enter the number only.', meter: function (cm) { return 'That is ' + cm + ' cm.'; },
    uebernehmen: function (w) { return 'Use ' + w; },
    plausLaenge: 'Unusual relative to your height. Please measure once more – if the figure is right, leave it.',
    plausBreite: 'Unusual relative to your chest. Please measure once more – if the figure is right, leave it.',
    zollVerdacht: 'Measured in inches? Switch to “in · lb” in “Before you start”.',
    fehlerliste: function (n) { return n === 1 ? 'One detail is missing' : n + ' details are missing'; },
    vorbefuellt: 'Taken from your order confirmation.', nochNicht: 'We will match your measurements by your email address.',
    bestellnrEntfaellt: 'Order number (not needed)', bestellnrLeer: 'Please enter your order number – or choose “I have not ordered yet.”',
    pruefen: 'please check', aendern: 'change', strich: '—',
    entwurf: 'Draft saved in this tab.', entwurfZurueck: 'Your draft from this tab is back.', verwerfen: 'Discard draft',
    robe: function (n) { return 'Your robe: ' + n; },
    laden: 'Loading the bust …', keinWebgl: 'The 3D bust is not available on this device – the picture and text show every measurement.',
    formName: { damen: 'women’s form', herren: 'men’s form' },
    buesteAria: function (f, nr, titel, text) { return 'Rotatable ' + f + ' with measuring tape, ' + nr + ' ' + titel + ': ' + text; },
    filmAlt: function (titel, text) { return 'Still from the measuring film: ' + titel + '. ' + text; },
    gewicht: 'Body weight', original: function (u) { return u === 'in' ? 'in · lb (original figures)' : 'cm · kg'; }
  };
  var TX = D.texte || {};

  /* ---------------- Nach dem Senden: Übersicht zum Sichern, Entwurf löschen ---------------- */
  var statusBox = $('mbf-status');
  if (statusBox) {
    var beleg = sLesen(BKEY);
    sLoeschen(SKEY); sLoeschen(BKEY);
    if (beleg && beleg.z && beleg.z.length) {
      $('mbf-beleg').innerHTML = '<table><tbody>' + beleg.z.map(function (r) { return '<tr><th scope="row">' + esc(r[0]) + '</th><td>' + esc(r[1]) + '</td></tr>'; }).join('') + '</tbody></table>';
      $('mbf-beleg-hinweis').hidden = false;
      var dk = $('mbf-drucken'); dk.hidden = false; dk.addEventListener('click', function () { window.print(); });
    }
    try { statusBox.focus({ preventScroll: true }); } catch (x) {}
    return;
  }
  var form = $('mbf-form'); if (!form) return;
  form.noValidate = true;               // eigene Prüfung mit Text am Feld; ohne Skript prüft der Browser (required/pattern)
  wurzel.classList.add('mbf--bereit');

  var schritte = alle('.mbf__schritt', form);
  var massSchritte = alle('.mbf__schritt--mass', form);
  var massFelder = alle('input[data-mbf-feld="mass"]', form);
  var senden = $('mbf-senden');
  var modus = form.classList.contains('mbf--karte') ? 'karte' : 'gefuehrt';
  var aktiv = (schritte.filter(function (s) { return s.classList.contains('is-aktiv'); })[0] || schritte[0]).getAttribute('data-schritt');
  var einheit = 'cm', vomUeberblick = false, tiefe = 0, hist = [], vorbefuellt = false, beruehrt = false, sendenGeklickt = false;
  var feldNr = function (el) { return el.getAttribute('data-mbf-nr'); };
  var schrittVon = function (el) { var s = el.closest('.mbf__schritt'); return s ? s.getAttribute('data-schritt') : null; };

  /* ---------------- Kopf messen: Fokus nie verdeckt (WCAG 2.4.11) ---------------- */
  var stapel = 0, buehneOffen = false;
  function kopfGruppe() { return alle('.shopify-section-group-header-group'); }
  function kopfMessen() {
    var summe = 0, oben = 0;
    kopfGruppe().forEach(function (el) {
      var r = el.getBoundingClientRect(); var pos = getComputedStyle(el).position;
      summe += r.height;
      if ((pos === 'sticky' || pos === 'fixed') && r.bottom > 0 && r.top < 400) oben = Math.max(oben, r.bottom);
    });
    stapel = Math.round(summe) || 80;
    wurzel.style.setProperty('--mbf-oben', Math.max(0, Math.round(oben)) + 'px');
    var zusatz = 0;
    if (buehneOffen && window.innerWidth < 1024) { var b = $('mbf-buehne'); if (b && !b.hidden) zusatz = b.getBoundingClientRect().height + 8; }
    document.documentElement.style.scrollPaddingTop = (stapel + 16 + Math.round(zusatz)) + 'px';
  }
  var kopfRaf = 0;
  function kopfBald() { if (kopfRaf) return; kopfRaf = requestAnimationFrame(function () { kopfRaf = 0; kopfMessen(); }); }
  window.addEventListener('scroll', kopfBald, { passive: true });
  window.addEventListener('resize', kopfBald);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', function () {
    var eng = window.visualViewport.height < window.innerHeight * 0.8 && window.innerWidth < 1024;
    if (wurzel.classList.contains('mbf--tastatur') !== eng) { wurzel.classList.toggle('mbf--tastatur', eng); kopfBald(); }
  });

  /* ---------------- Zahlen ---------------- */
  var MUSTER = /^\s*(0*[1-9][0-9]*([.,][0-9]+)?|0*[.,][0-9]*[1-9][0-9]*)\s*$/;   // = Stufe 1 (pattern im Liquid)
  function zahl(v) { v = String(v == null ? '' : v); if (!MUSTER.test(v)) return null; return parseFloat(v.trim().replace(',', '.')); }
  function fmt(n) { var s = String(Math.round(n * 100) / 100); return DE ? s.replace('.', ',') : s; }

  /* ---------------- Folge, Anzeige, Fortschritt ---------------- */
  function folge() { return schritte.filter(function (s) { return !s.hasAttribute('data-mbf-aus'); }).map(function (s) { return s.getAttribute('data-schritt'); }); }
  function sichtbareMasse() { return massFelder.filter(function (f) { return !f.closest('[data-mbf-aus]'); }); }
  function stand() {
    var f = folge(), i = f.indexOf(aktiv) + 1, mf = sichtbareMasse();
    var ok = mf.filter(function (e) { var z = zahl(e.value); return z !== null && z > 0; }).length;
    $('mbf-stand').innerHTML = (modus === 'gefuehrt' ? T.schritt(i, f.length) + ' · ' : '') + T.masse(ok, mf.length);
    $('mbf-balken').style.width = (modus === 'gefuehrt' ? Math.round(100 * i / f.length) : Math.round(100 * ok / Math.max(1, mf.length))) + '%';
    var massen = f.filter(function (x) { return /^\d\d$/.test(x); });
    massSchritte.forEach(function (s) { var k = massen.indexOf(s.getAttribute('data-schritt')); var u = s.querySelector('[data-mbf-massu]'); if (u) u.textContent = k >= 0 ? T.massU(k + 1, massen.length) : ''; });
  }
  function zeige(id, opt) {
    opt = opt || {};
    var f = folge(); if (f.indexOf(id) < 0) id = f[0];
    aktiv = id;
    schritte.forEach(function (s) { s.classList.toggle('is-aktiv', s.getAttribute('data-schritt') === id); });
    if (id === 'ueberblick') ueberblick();
    alle('[data-mbf-nav="ueberblick"]', form).forEach(function (b) { b.hidden = !vomUeberblick || id === 'ueberblick'; });
    stand();
    buesteFolgen();
    if (modus === 'gefuehrt' && opt.scroll !== false) {
      kopfMessen();
      var anker = $('mbf-folge');
      var ziel = anker.getBoundingClientRect().top + window.scrollY - stapel - 8;
      if (Math.abs(window.scrollY - ziel) > 4) scrolle(ziel);
    }
    if (modus === 'gefuehrt' && opt.fokus !== false) {
      var s = $('mbf-s-' + id);
      var feld = s.classList.contains('mbf__schritt--mass') ? s.querySelector('input[data-mbf-feld="mass"]') : null;
      try { (feld || s.querySelector('.mbf__titel')).focus({ preventScroll: true }); } catch (x) {}
    }
    speichereBald();
  }
  function geheZu(id, opt) {
    opt = opt || {};
    if (modus !== 'gefuehrt') { var z = $('mbf-s-' + id); if (z) { var f = opt.feld && $(opt.feld); if (f) f.focus(); } return; }
    if (id !== aktiv) { tiefe++; hist.length = tiefe; hist.push(id); try { history.pushState({ mbf: id, t: tiefe }, '', '#mbf-' + id); } catch (x) {} }
    zeige(id, opt);
    if (opt.feld) { var el = $(opt.feld); if (el) try { el.focus({ preventScroll: false }); } catch (x) {} }
  }
  window.addEventListener('popstate', function (e) {
    if (modus !== 'gefuehrt') return;
    var id = e.state && e.state.mbf ? e.state.mbf : (/^#mbf-(.+)$/.exec(location.hash) || [])[1] || 'bestellung';
    tiefe = e.state && e.state.t ? e.state.t : 0; if (!hist[tiefe]) hist[tiefe] = id;
    zeige(id);
  });
  function modusSetzen(m, still) {
    modus = m;
    form.classList.toggle('mbf--gefuehrt', m === 'gefuehrt'); form.classList.toggle('mbf--karte', m === 'karte');
    var k = $('mbf-modus'); k.textContent = m === 'gefuehrt' ? T.karte : T.gefuehrt; k.setAttribute('aria-pressed', String(m === 'karte'));
    if (m === 'karte') {
      ueberblick();
      alle('.mbf__schritt--mass .mbf__medien', form).forEach(function (b) { b.classList.remove('is-offen'); });
      alle('.mbf__anleitung-knopf', form).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    stand(); buesteFolgen();
    if (!still) speichereBald();
  }

  /* ---------------- Abhängigkeiten: Bestellnummer, Schnitt, Größenliste ---------------- */
  var bestellnr = $('mbf-bestellnr'), nochNicht = $('mbf-nochnicht');
  var hBestellnr = $('mbf-h-bestellnr'), hBestellnrText = hBestellnr ? hBestellnr.textContent : '';
  var lBestellnr = $('mbf-l-bestellnr'), lBestellnrText = lBestellnr ? lBestellnr.textContent : '';
  function pflichtLogik() {
    var nn = nochNicht && nochNicht.checked;
    bestellnr.required = !nn; bestellnr.disabled = !!nn;
    if (nn) meldung(bestellnr, '');
    lBestellnr.textContent = nn ? T.bestellnrEntfaellt : lBestellnrText;
    hBestellnr.textContent = nn ? T.nochNicht : (vorbefuellt && bestellnr.value ? T.vorbefuellt : hBestellnrText);
    stand();
  }
  function gewaehlterSchnitt() { var r = form.querySelector('input[data-mbf-schnitt]:checked'); return r ? r.getAttribute('data-mbf-schnitt') : ''; }
  var groesse = $('mbf-groesse'), groessenVorlage = groesse ? alle('optgroup', groesse).map(function (g) { return g.cloneNode(true); }) : [];
  function groessenFiltern() {
    if (!groesse) return;
    var s = gewaehlterSchnitt(), alt = groesse.value;
    alle('optgroup', groesse).forEach(function (g) { g.remove(); });
    groessenVorlage.forEach(function (g) { if (!s || g.getAttribute('data-mbf-schnitt') === s) groesse.appendChild(g.cloneNode(true)); });
    groesse.value = alt; if (groesse.value !== alt) groesse.value = '';
  }
  function schnittAnwenden() {
    var s = gewaehlterSchnitt();
    alle('[data-mbf-damen]', form).forEach(function (z) { if (s === 'herren') z.setAttribute('data-mbf-aus', ''); else z.removeAttribute('data-mbf-aus'); });
    groessenFiltern();
    if (bueste) bueste.form(s === 'damen' ? 'damen' : 'herren', true);
    buesteFormKnoepfe(s === 'damen' ? 'damen' : 'herren');
    stand();
  }

  /* ---------------- Einheiten (RS): Anzeige und Umrechnung ---------------- */
  function einheitAnzeigen(u) {
    alle('[data-mbf-einheit]', form).forEach(function (s) { s.textContent = u; });
    alle('[data-mbf-einheit-text]', form).forEach(function (s) { s.textContent = T.inEinheit[u]; });
    alle('[data-mbf-beispiel]', form).forEach(function (s) { s.textContent = T.beispiel[u]; });
    var ug = $('mbf-u-gewicht'); if (ug) ug.textContent = u === 'in' ? 'lb' : 'kg';
    alle('[data-mbf-gewicht-text]', form).forEach(function (s) { s.textContent = T.gewichtIn[u]; });
  }
  function setzeEinheit(u, umrechnen) {
    var alt = einheit; einheit = u; einheitAnzeigen(u);
    if (umrechnen && alt !== u) {
      massFelder.forEach(function (i) { var z = zahl(i.value); if (z === null) return; var n = u === 'in' ? z / 2.54 : z * 2.54; i.value = fmt(u === 'in' ? Math.round(n * 4) / 4 : Math.round(n * 10) / 10); pruefe(i, true); });
      var g = $('mbf-gewicht'), zg = g ? zahl(g.value) : null;
      if (zg !== null) g.value = fmt(Math.round((u === 'in' ? zg / 0.45359237 : zg * 0.45359237) * 10) / 10);
    }
    stand();
  }

  /* ---------------- Prüfung: Format hart, Plausibilität weich (Hinweis, nie Sperre) ---------------- */
  function meldung(el, art, text, knopf) {
    var p = el.hasAttribute('data-mbf-nr') ? $('mbf-e-' + feldNr(el)) : $(el.id.replace(/^mbf-/, 'mbf-e-'));
    if (!p) return;
    var schluessel = (art || '') + '|' + (text || '') + '|' + (knopf ? knopf.wert : '');
    if (art && !p.hidden && p.getAttribute('data-k') === schluessel) { if (art === 'fehler') el.setAttribute('aria-invalid', 'true'); return; }   // unverändert: nicht neu bauen (sonst geht ein Klick auf „übernehmen“ verloren)
    p.setAttribute('data-k', schluessel);
    p.innerHTML = '';
    if (!art) { p.hidden = true; p.className = 'mbf__fehler'; el.removeAttribute('aria-invalid'); return; }
    p.hidden = false; p.className = art === 'hinweis' ? 'mbf__fehler mbf__hinweis' : 'mbf__fehler';
    p.appendChild(document.createTextNode(text));
    if (art === 'fehler') el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
    if (knopf) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'mbf__klein-knopf'; b.textContent = knopf.text;
      b.addEventListener('mousedown', function (ev) { ev.preventDefault(); });   // Fokus bleibt im Feld, kein Neuaufbau durch focusout
      b.addEventListener('click', function () { el.value = knopf.wert; pruefe(el, true); stand(); speichereBald(); el.focus(); });
      p.appendChild(document.createTextNode(' ')); p.appendChild(b);
    }
  }
  function leerText(el) {
    var t = el.getAttribute('data-mbf-leer');
    if (el === bestellnr) return t || T.bestellnrLeer;
    if (el.type === 'email') return TX.emailLeer || T.leer('E-Mail');
    return t || T.leer(el.getAttribute('data-mbf-akk') || '');
  }
  function pruefe(el, weich) {
    if (el.disabled || el.closest('[data-mbf-aus]')) return true;
    var v = el.value.trim(), art = el.getAttribute('data-mbf-feld');
    if (art === 'email') {
      if (!v) { if (!weich) meldung(el, 'fehler', leerText(el)); else if (el.hasAttribute('aria-invalid')) meldung(el, 'fehler', leerText(el)); return false; }
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); meldung(el, ok ? '' : 'fehler', TX.email); return ok;
    }
    if (art === 'bestellnr' || art === 'vorname' || art === 'nachname') {
      if (!v && el.required) { if (!weich || el.hasAttribute('aria-invalid')) meldung(el, 'fehler', leerText(el)); return false; }
      meldung(el, ''); return true;
    }
    if (art !== 'mass' && art !== 'gewicht') return true;
    if (!v) { if (el.required) { if (!weich || el.hasAttribute('aria-invalid')) meldung(el, 'fehler', leerText(el)); return false; } meldung(el, ''); return true; }
    var m = /^(\d)[.,](\d{1,2})\s*m$/i.exec(v);
    if (m && einheit === 'cm' && art === 'mass') { var cm = Math.round(parseFloat(m[1] + '.' + m[2]) * 100); meldung(el, 'fehler', T.meter(cm), { text: T.uebernehmen(cm), wert: String(cm) }); return false; }
    var mitEinheit = /^(\d+(?:[.,]\d+)?)\s*(cm|in|inch|inches|zoll|kg|lb|lbs|")\s*$/i.exec(v);
    if (mitEinheit && zahl(mitEinheit[1]) !== null) { meldung(el, 'fehler', T.nurZahl, { text: T.uebernehmen(mitEinheit[1]), wert: mitEinheit[1] }); return false; }
    var z = zahl(v);
    if (z === null) { meldung(el, 'fehler', /^\s*-/.test(v) || /^\s*0*([.,]0*)?\s*$/.test(v) ? TX.negativ : TX.format); return false; }
    meldung(el, '');
    if (art === 'mass') {
      var nr = feldNr(el), k = zahl(($('mbf-m01') || {}).value), b = zahl(($('mbf-m03') || {}).value);
      if (nr === '02' && k) { var q = z / k; if (q < 0.55 || q > 0.75) meldung(el, 'hinweis', T.plausLaenge); }
      if (nr === '07' && b) { var r = z / b; if (r < 0.25 || r > 0.5) meldung(el, 'hinweis', T.plausBreite); }
      if (RS_EINHEITEN && einheit === 'cm' && nr === '01' && z < 100) meldung(el, 'hinweis', T.zollVerdacht);
    }
    return true;
  }
  function pruefeSchritt(id) {
    var s = $('mbf-s-' + id), fehler = [];
    if (!s || s.hasAttribute('data-mbf-aus')) return fehler;
    alle('input[data-mbf-feld]', s).forEach(function (el) { if (!pruefe(el, false)) fehler.push(el); });
    return fehler;
  }

  /* ---------------- Überblick ---------------- */
  function feldTitel(el) {
    if (el.getAttribute('data-mbf-titel')) return el.getAttribute('data-mbf-nr') + ' ' + el.getAttribute('data-mbf-titel');
    var l = form.querySelector('label[for="' + el.id + '"]'); return l ? l.textContent.trim() : el.id;
  }
  function massWert(el) {
    var v = el.value.trim(), z = zahl(v);
    if (!v) return { t: T.strich };
    if (z === null) return { t: v, pruefen: true };
    if (einheit === 'in') return { t: v + ' in (' + fmt(Math.round(z * 25.4) / 10) + ' cm)' };
    return { t: v + ' cm' };
  }
  function zeilen() {
    var z = [], nn = nochNicht && nochNicht.checked;
    z.push([D.bestellnr, nn ? (DE ? 'noch nicht bestellt' : 'not ordered yet') : (bestellnr.value.trim() || T.strich), 'bestellung', 'mbf-bestellnr']);
    z.push([D.vorname + ' · ' + D.nachname, ($('mbf-vorname').value + ' ' + $('mbf-nachname').value).trim() || T.strich, 'bestellung', 'mbf-vorname']);
    z.push([D.email, $('mbf-email').value.trim() || T.strich, 'bestellung', 'mbf-email']);
    var s = gewaehlterSchnitt(); z.push([D.schnitt, s ? (s === 'damen' ? D.damen : D.herren) : T.strich, 'vorbereitung', 'mbf-schnitt-damen']);
    sichtbareMasse().forEach(function (i) { var w = massWert(i); z.push([feldTitel(i), w.t, schrittVon(i), i.id, w.pruefen]); });
    if (groesse) z.push([D.groesse, groesse.value ? groesse.options[groesse.selectedIndex].text + ' (' + (groesse.value.split(' · ')[0]) + ')' : T.strich, 'ergaenzung', 'mbf-groesse']);
    var gw = $('mbf-gewicht'); if (gw) { var zw = zahl(gw.value); z.push([D.gewicht, gw.value.trim() ? (zw === null ? gw.value.trim() : gw.value.trim() + ' ' + (einheit === 'in' ? 'lb (' + fmt(Math.round(zw * 4.5359237) / 10) + ' kg)' : 'kg')) : T.strich, 'ergaenzung', 'mbf-gewicht', gw.value.trim() && zw === null]); }
    var st = alle('.mbf__chips input:checked', form).map(function (c) { return c.nextElementSibling.textContent.trim(); });
    z.push([D.statur, st.length ? st.join(', ') : T.strich, 'ergaenzung', 'mbf-st-1']);
    var we = $('mbf-weiteres'); if (we && we.value.trim()) z.push([D.weiteres, we.value.trim(), 'ergaenzung', 'mbf-weiteres']);
    return z;
  }
  function ueberblick() {
    var ziel = $('mbf-ueberblick'); if (!ziel) return;
    ziel.innerHTML = '<table><tbody>' + zeilen().map(function (r) {
      var w = r[4] ? '<span class="mbf__pruefen">' + esc(r[1]) + ' · ' + T.pruefen + '</span>' : esc(r[1]);
      return '<tr><th scope="row">' + esc(r[0]) + '</th><td>' + w + ' <a href="#mbf-' + r[2] + '" data-mbf-ziel="' + r[2] + '" data-mbf-feld-ziel="' + r[3] + '">' + T.aendern + '<span class="mbf__vh"> ' + esc(r[0]) + '</span></a></td></tr>';
    }).join('') + '</tbody></table>';
  }

  /* ---------------- Senden: einmal an /contact, nur über den Knopf ---------------- */
  var versandOrt = null;
  function versandZurueck() {
    if (versandOrt) { versandOrt.remove(); versandOrt = null; }
    alle('[data-mbf-name]', form).forEach(function (el) { el.name = el.getAttribute('data-mbf-name'); el.removeAttribute('data-mbf-name'); });
  }
  function versandVorbereiten() {
    versandZurueck();
    var orig = $('mbf-original');
    if (!RS_EINHEITEN || !orig) return;
    if (einheit !== 'in') { orig.value = 'cm · kg'; return; }
    // Das Atelier erhält IMMER cm: sichtbare Felder bleiben in Zoll, gesendet werden versteckte Felder in cm unter denselben Namen.
    versandOrt = document.createElement('div'); versandOrt.hidden = true; form.appendChild(versandOrt);
    var liste = [];
    massFelder.concat([$('mbf-gewicht')]).forEach(function (el) {
      if (!el || !el.name) return;
      var z = zahl(el.value), istGewicht = el.getAttribute('data-mbf-feld') === 'gewicht';
      if (el.value.trim()) liste.push((istGewicht ? T.gewicht : el.getAttribute('data-mbf-titel')) + ' ' + el.value.trim() + (istGewicht ? ' lb' : ' in'));
      var h = document.createElement('input'); h.type = 'hidden'; h.name = el.name;
      h.value = z === null ? el.value.trim() : String(Math.round((istGewicht ? z * 0.45359237 : z * 2.54) * 10) / 10);
      el.setAttribute('data-mbf-name', el.name); el.removeAttribute('name');
      versandOrt.appendChild(h);
    });
    orig.value = 'in · lb — ' + liste.join(' · ');
  }
  function fehlerlisteZeigen(fehler) {
    var ort = $('mbf-fehlerliste-ort');
    ort.innerHTML = '<div class="mbf__fehlerliste" role="alert" tabindex="-1" id="mbf-fehlerliste"><h2 class="mbf__fehlerliste-titel">' + T.fehlerliste(fehler.length) + '</h2><ul>' +
      fehler.map(function (el) { var sc = schrittVon(el); return '<li><a href="#mbf-' + sc + '" data-mbf-ziel="' + sc + '" data-mbf-feld-ziel="' + el.id + '">' + esc(feldTitel(el)) + '</a></li>'; }).join('') + '</ul></div>';
    kopfMessen();
    scrolle(ort.getBoundingClientRect().top + window.scrollY - stapel - 16);
    try { $('mbf-fehlerliste').focus({ preventScroll: true }); } catch (x) {}
  }
  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    // Nur der Knopf sendet. Jede andere Auslösung (Enter, fremdes Skript) wird hier abgefangen – vor allen Formular-Listenern.
    var knopf = e.submitter || (sendenGeklickt ? senden : null);
    if (knopf !== senden) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    var fehler = [];
    folge().forEach(function (id) { if (id !== 'ueberblick') fehler = fehler.concat(pruefeSchritt(id)); });
    if (fehler.length) { e.preventDefault(); e.stopImmediatePropagation(); fehlerlisteZeigen(fehler); return; }
    $('mbf-fehlerliste-ort').innerHTML = '';
    sSchreiben(BKEY, { z: zeilen().map(function (r) { return [r[0], r[1]]; }), t: Date.now() });
    versandVorbereiten();
  }, true);
  senden.addEventListener('click', function () { sendenGeklickt = true; setTimeout(function () { sendenGeklickt = false; }, 0); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { versandZurueck(); } });

  /* ---------------- Entwurf: nur in diesem Tab ---------------- */
  var speicherTimer = 0;
  function speichere() {
    var d = { s: aktiv, m: modus, u: einheit, o: vomUeberblick, v: {} };
    alle('input,select,textarea', form).forEach(function (el) {
      if (!el.id || el.type === 'hidden' || el.id === 'mbf-original') return;
      d.v[el.id] = (el.type === 'checkbox' || el.type === 'radio') ? el.checked : el.value;
    });
    if (sSchreiben(SKEY, d)) entwurfZeile(T.entwurf);
  }
  function speichereBald() { if (!beruehrt) return; clearTimeout(speicherTimer); speicherTimer = setTimeout(speichere, 250); }
  function entwurfZeile(text) { var e = $('mbf-entwurf'); if (e) e.innerHTML = esc(text) + '<button type="button" id="mbf-verwerfen">' + esc(T.verwerfen) + '</button>'; }
  function lade() {
    var d = sLesen(SKEY); if (!d || !d.v) return null; beruehrt = true;
    Object.keys(d.v).forEach(function (id) { var el = $(id); if (!el || !form.contains(el)) return; if (el.type === 'checkbox' || el.type === 'radio') el.checked = !!d.v[id]; else if (el.tagName !== 'SELECT') el.value = d.v[id]; });
    if (d.u === 'in' && RS_EINHEITEN) { var ri = $('mbf-einheit-in'); if (ri) ri.checked = true; setzeEinheit('in', false); }
    schnittAnwenden();
    if (groesse && d.v['mbf-groesse'] !== undefined) { groesse.value = d.v['mbf-groesse']; if (groesse.value !== d.v['mbf-groesse']) groesse.value = ''; }
    vomUeberblick = !!d.o;
    entwurfZeile(T.entwurfZurueck);
    return d;
  }
  function verwerfen() {
    sLoeschen(SKEY); clearTimeout(speicherTimer); beruehrt = false; form.reset(); versandZurueck();
    alle('[aria-invalid]', form).forEach(function (el) { el.removeAttribute('aria-invalid'); });
    alle('.mbf__fehler', form).forEach(function (p) { p.hidden = true; p.innerHTML = ''; });
    $('mbf-fehlerliste-ort').innerHTML = '';
    vomUeberblick = false; vorbefuellt = false; einheit = 'cm'; einheitAnzeigen('cm');
    schnittAnwenden(); urlParameter(); pflichtLogik();
    $('mbf-entwurf').textContent = '';
    modusSetzen('gefuehrt', true); tiefe = 0;
    hist = ['bestellung'];
    try { history.replaceState({ mbf: 'bestellung', t: 0 }, '', location.pathname + location.search); } catch (x) {}
    zeige('bestellung');
  }

  /* ---------------- Aus der URL: nur die Bestellnummer (und leise der Robenname) ---------------- */
  function urlParameter() {
    var q; try { q = new URLSearchParams(location.search); } catch (x) { return; }
    var nr = (q.get('bestellung') || q.get('bestellnr') || q.get('order') || '').trim(); /* bestellnr: Link aus der Bestellbestätigung (Board V2 01.10.2026, Inventur Nr. 41) */
    if (nr && /^#?[A-Za-z0-9-]{1,24}$/.test(nr) && !bestellnr.value) { bestellnr.value = /^\d+$/.test(nr) ? '#' + nr : nr; vorbefuellt = true; }
    var h = (q.get('robe') || '').trim().toLowerCase();
    if (h && /^[a-z0-9][a-z0-9-]{0,120}$/.test(h) && window.fetch) {
      fetch('/products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (p && p.title) { var z = $('mbf-robe'); z.textContent = T.robe(p.title); z.hidden = false; }
      }).catch(function () {});
    }
  }

  /* ---------------- 3D-Maßbüste (freiwillig, erst auf Knopfdruck) ---------------- */
  var bueste = null, buesteLaedt = false, buesteWunsch = false, buesteFehler = false, buesteNr = null, letzterKnopf = null;
  var buehne = $('mbf-buehne'), raster = $('mbf-raster');
  var webgl = (function () { try { var c = document.createElement('canvas'); var g = c.getContext('webgl2') || c.getContext('webgl'); if (!g) return false; var l = g.getExtension('WEBGL_lose_context'); if (l) l.loseContext(); return true; } catch (x) { return false; } })();
  alle('[data-mbf-bueste-zeigen]', form).forEach(function (k) {
    var s = k.closest('.mbf__schritt'); var art = s.getAttribute('data-mbf-bueste');
    if (art === 'film' || webgl) k.hidden = false;
  });
  function massInfo(nr) {
    var s = $('mbf-s-' + nr); if (!s) return null; var f = s.querySelector('input[data-mbf-feld="mass"]');
    return { nr: nr, s: s, art: s.getAttribute('data-mbf-bueste'), film: s.getAttribute('data-mbf-film'), titel: f.getAttribute('data-mbf-titel'), text: ($('mbf-t-' + nr) || {}).textContent || '' };
  }
  function buesteFormKnoepfe(name) { alle('[data-mbf-form]', buehne).forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-mbf-form') === name)); }); }
  function knoepfeMarkieren() { alle('[data-mbf-bueste-zeigen]', form).forEach(function (k) { k.setAttribute('aria-expanded', String(buehneOffen && k.getAttribute('data-mbf-bueste-zeigen') === buesteNr)); }); }
  function buehneZeigen(an) {
    buehneOffen = an; buehne.hidden = !an; raster.classList.toggle('is-buehne', an);
    if (bueste) bueste.pausiere(!an || (buesteNr && massInfo(buesteNr) && massInfo(buesteNr).art === 'film'));
    knoepfeMarkieren(); kopfMessen();
  }
  // Handy: Feld unter der klebenden Bühne sichtbar halten (Büste und Feld gleichzeitig, nie weg vom Feld)
  function feldUnterBuehne() {
    if (!buehneOffen || window.innerWidth >= 1024) return;
    var f = modus === 'gefuehrt' ? form.querySelector('.mbf__schritt.is-aktiv input[data-mbf-feld="mass"]') : (document.activeElement && document.activeElement.getAttribute && document.activeElement.getAttribute('data-mbf-nr') ? document.activeElement : null);
    if (!f) return;
    var hoch = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var r = f.getBoundingClientRect(), bu = buehne.getBoundingClientRect();
    var unten = r.bottom + 20 - hoch; if (unten > 0) { scrolle(unten, true); return; }
    var oben = bu.bottom + 8 - r.top; if (oben > 0 && bu.top <= parseFloat(getComputedStyle(wurzel).getPropertyValue('--mbf-oben')) + 2) scrolle(-oben, true);
  }
  function kurzZeile(info) { $('mbf-kurz').innerHTML = '<b class="mbf__nr">' + esc(info.nr) + '</b>' + esc(info.titel); }
  function buesteZeige(nr) {
    var info = massInfo(nr); if (!info || !info.art) { buehneZeigen(false); return; }
    buesteNr = nr; buehneZeigen(true); kurzZeile(info);
    var film = $('mbf-film'), canvas = $('mbf-canvas');
    if (info.art === 'film' || !webgl || buesteFehler) {
      if (info.film) { film.src = info.film; film.alt = T.filmAlt(info.titel, info.text); film.hidden = false; }
      if (canvas) canvas.hidden = true; $('mbf-nummer').hidden = true; $('mbf-drehen').hidden = true; $('mbf-poster').hidden = true;
      if (bueste) bueste.pausiere(true);
      knoepfeMarkieren(); requestAnimationFrame(feldUnterBuehne); return;
    }
    film.hidden = true; if (canvas) canvas.hidden = false;
    if (bueste) { bueste.pausiere(false); bueste.zeige(info.art); $('mbf-drehen').hidden = false; }
    else buesteLaden(info);
    knoepfeMarkieren();
    requestAnimationFrame(feldUnterBuehne);
  }
  // Laden per Skript-Element (kein import(): Shopify minifiziert Theme-JS und schreibt import() zu require() um – gemessen 25.09.)
  function buesteModul() {
    return new Promise(function (ok, nein) {
      /* 25.09.: ein gemeinsames Büsten-Modul mit den Inhaltsseiten (assets/bb-massbueste.js, meldet sich als __bbMassbueste) */
      var fertig = function () { return (window.__bbMassbueste && window.__bbMassbueste.ladeBueste && window.__bbMassbueste) || (window.mbfBueste && window.mbfBueste.ladeBueste && window.mbfBueste); };
      if (fertig()) { ok(fertig()); return; }
      var sk = document.createElement('script'); sk.type = 'module'; /* bb-massbueste.js ist ein ES-Modul (endet mit export) */ sk.src = wurzel.getAttribute('data-bueste-js'); sk.async = true;
      sk.onload = function () { if (fertig()) ok(fertig()); else nein(new Error('Modul leer')); };
      sk.onerror = function () { nein(new Error('Modul nicht geladen')); };
      document.head.appendChild(sk);
    });
  }
  function buesteLaden(info) {
    if (buesteLaedt) return; buesteLaedt = true;
    var poster = $('mbf-poster'); if (!poster.getAttribute('src')) poster.src = wurzel.getAttribute('data-poster'); poster.hidden = false;
    $('mbf-laden').textContent = T.laden;
    var canvas = document.createElement('canvas'); canvas.id = 'mbf-canvas'; canvas.setAttribute('role', 'img'); canvas.setAttribute('aria-label', T.buesteAria(T.formName.herren, info.nr, info.titel, info.text));
    $('mbf-leinwand').insertBefore(canvas, poster);
    buesteModul().then(function (mod) { return mod.ladeBueste(); }).then(function (api) {
      bueste = api.mountBueste(canvas, {
        marke: $('mbf-nummer'),
        onChange: function (m, fname) {
          var i2 = massInfo(buesteNr) || info; var fk = /Damen|Women/i.test(fname) ? 'damen' : 'herren';
          canvas.setAttribute('aria-label', T.buesteAria(T.formName[fk], i2.nr, i2.titel, i2.text));
          buesteFormKnoepfe(fk);
        }
      });
      canvas.addEventListener('erstesbild', function () { poster.hidden = true; $('mbf-laden').textContent = ''; $('mbf-drehen').hidden = false; }, { once: true });
      var s = gewaehlterSchnitt(); bueste.form(s === 'damen' ? 'damen' : 'herren', true);
      var aktuell = massInfo(buesteNr) || info;
      if (aktuell.art === 'film') { bueste.pausiere(true); bueste.eroeffne(null); } else bueste.eroeffne(aktuell.art);
      if (!buehneOffen) bueste.pausiere(true);
    }).catch(function (err) {
      try { console.warn('mbf-bueste', err && err.message, err && err.stack); } catch (x) {}
      buesteFehler = true; canvas.remove(); poster.hidden = true;
      $('mbf-laden').textContent = T.keinWebgl;
      var i3 = massInfo(buesteNr) || info; if (i3.film) buesteZeige(i3.nr);
    });
  }
  function buesteFolgen() {
    if (!buehne) return;
    if (!buesteWunsch) { if (buehneOffen) buehneZeigen(false); return; }
    var nr = null;
    if (modus === 'gefuehrt') nr = /^\d\d$/.test(aktiv) ? aktiv : null;
    else { var a = document.activeElement; nr = a && a.getAttribute && a.getAttribute('data-mbf-nr') || buesteNr; }
    var info = nr && massInfo(nr);
    if (!info || !info.art || info.s.hasAttribute('data-mbf-aus')) { if (buehneOffen) buehneZeigen(false); return; }
    buesteZeige(nr);
  }
  $('mbf-schliessen').addEventListener('click', function () {
    buesteWunsch = false; buehneZeigen(false);
    var k = letzterKnopf && document.body.contains(letzterKnopf) && letzterKnopf.offsetParent ? letzterKnopf : form.querySelector('.mbf__schritt.is-aktiv [data-mbf-bueste-zeigen]');
    if (k) try { k.focus({ preventScroll: true }); } catch (x) {}
  });
  alle('[data-mbf-form]', buehne).forEach(function (b) { b.addEventListener('click', function () { var n = b.getAttribute('data-mbf-form'); buesteFormKnoepfe(n); if (bueste) bueste.form(n, false); }); });

  /* ---------------- Ereignisse ---------------- */
  form.addEventListener('input', function (e) {
    var el = e.target; versandZurueck(); beruehrt = true;
    if (el.getAttribute('aria-invalid') === 'true') pruefe(el, true);
    stand(); speichereBald();
  });
  form.addEventListener('change', function (e) {
    var el = e.target; beruehrt = true;
    if (el.hasAttribute('data-mbf-schnitt')) schnittAnwenden();
    if (el.name === 'mbf_einheit') setzeEinheit(el.value, true);
    if (el === nochNicht) pflichtLogik();
    speichereBald();
  });
  form.addEventListener('focusout', function (e) { var el = e.target; if (el.matches && el.matches('input[data-mbf-feld]') && (el.value.trim() || el.hasAttribute('aria-invalid'))) pruefe(el, true); });
  // Fokus nie verdeckt (WCAG 2.4.11): liegt das fokussierte Element unter dem Klebekopf oder der Bühne, frei scrollen.
  // Nach oben scrollen lässt den Kopf wieder erscheinen – deshalb gegen den vollen Stapel (Ankündigung + Kopf) rechnen.
  function fokusFrei(el) {
    if (!el || !el.getBoundingClientRect || el === document.body || buehne.contains(el)) return;
    var r = el.getBoundingClientRect(); if (!r.height) return;
    // Gegen den vollen Stapel rechnen: der Kopf fährt beim Hochscrollen animiert ein und ist im Moment der Messung oft erst halb da.
    var grenze = stapel + (buehneOffen && window.innerWidth < 1024 ? buehne.getBoundingClientRect().height : 0);
    if (r.top < grenze + 8) { scrolle(r.top - grenze - 16, true); return; }
    // unten schwebende Elemente (z. B. Chat-Knopf, „nach oben“): Element darüber schieben
    // unten schwebende Elemente (Chat, „nach oben“): feste Elemente am Seitenende, meist direkte Kinder von body
    var unten = 0, kand = [];
    Array.prototype.forEach.call(document.body.children, function (k) { kand.push(k); Array.prototype.forEach.call(k.children || [], function (k2) { kand.push(k2); }); });
    kand.forEach(function (k) {
      if (k.contains(el) || /^shopify-pc/.test(k.id || '')) return;
      var st = getComputedStyle(k); if (st.position !== 'fixed' || st.display === 'none' || st.visibility === 'hidden') return;
      var q = k.getBoundingClientRect(); if (!q.height || q.top < window.innerHeight / 2) return;
      if (q.left < r.right && q.right > r.left && q.top < r.bottom && q.bottom > r.top) unten = Math.max(unten, r.bottom - q.top + 8);
    });
    if (unten > 0) scrolle(unten, true);
  }
  form.addEventListener('focusin', function (e) {
    var el = e.target;
    if (modus === 'karte' && buesteWunsch && el.getAttribute && el.getAttribute('data-mbf-nr')) buesteZeige(el.getAttribute('data-mbf-nr'));
    requestAnimationFrame(function () { kopfMessen(); fokusFrei(el); });
  });
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.isComposing) return;
    var el = e.target;
    if (!el.matches || !el.matches('input:not([type=checkbox]):not([type=radio]):not([type=hidden])')) return;
    e.preventDefault();                              // Enter sendet nie
    if (modus === 'gefuehrt') { var b = el.closest('.mbf__schritt').querySelector('[data-mbf-nav="weiter"]'); if (b) b.click(); return; }
    var felder = alle('input:not([type=hidden]):not([disabled]),select,textarea', form).filter(function (x) { return x.offsetParent !== null; });
    var n = felder[felder.indexOf(el) + 1]; if (n) n.focus();
  });
  form.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-mbf-ziel]');
    if (a) {
      e.preventDefault();
      if (a.closest('#mbf-ueberblick')) vomUeberblick = true;
      geheZu(a.getAttribute('data-mbf-ziel'), { feld: a.getAttribute('data-mbf-feld-ziel'), fokus: false });
      return;
    }
    var nb = e.target.closest('[data-mbf-nav]');
    if (nb) {
      var f = folge(), i = f.indexOf(aktiv), art = nb.getAttribute('data-mbf-nav');
      if (art === 'zurueck') { var prev = f[Math.max(0, i - 1)]; if (tiefe > 0 && hist[tiefe - 1] === prev && history.state && history.state.mbf === aktiv) history.back(); else geheZu(prev); return; }
      var fe = pruefeSchritt(aktiv);
      if (fe.length) { try { fe[0].focus(); } catch (x) {} return; }
      if (art === 'ueberblick') { geheZu('ueberblick'); return; }
      if (art === 'weiter') { geheZu(f[Math.min(f.length - 1, i + 1)]); return; }
    }
    var k = e.target.closest('.mbf__anleitung-knopf');
    if (k) { var m = $(k.getAttribute('aria-controls')); var auf = k.getAttribute('aria-expanded') !== 'true'; k.setAttribute('aria-expanded', String(auf)); m.classList.toggle('is-offen', auf); return; }
    var bk = e.target.closest('[data-mbf-bueste-zeigen]');
    if (bk) {
      var nr = bk.getAttribute('data-mbf-bueste-zeigen');
      if (buehneOffen && buesteNr === nr) { buesteWunsch = false; buehneZeigen(false); return; }
      letzterKnopf = bk; buesteWunsch = true; buesteZeige(nr); return;
    }
  });
  $('mbf-modus').addEventListener('click', function () {
    beruehrt = true;
    modusSetzen(modus === 'gefuehrt' ? 'karte' : 'gefuehrt');
    if (modus === 'gefuehrt') { hist.length = tiefe; hist.push(aktiv); try { history.replaceState({ mbf: aktiv, t: tiefe }, '', '#mbf-' + aktiv); } catch (x) {} zeige(aktiv, { fokus: false }); }
  });
  wurzel.addEventListener('click', function (e) { if (e.target && e.target.id === 'mbf-verwerfen') verwerfen(); });

  /* ---------------- Start ---------------- */
  var d0 = lade();
  urlParameter();
  if (!d0) schnittAnwenden();
  pflichtLogik();
  if (d0 && d0.m === 'karte') modusSetzen('karte', true); else modusSetzen('gefuehrt', true);
  var h0 = /^#mbf-(.+)$/.exec(location.hash);
  var start = d0 ? ((h0 && h0[1]) || d0.s || 'bestellung') : 'bestellung';
  if (folge().indexOf(start) < 0) start = 'bestellung';
  hist = [start]; tiefe = 0;
  try { history.replaceState({ mbf: start, t: 0 }, '', d0 && start !== 'bestellung' ? '#mbf-' + start : location.pathname + location.search); } catch (x) {}
  kopfMessen();
  zeige(start, { fokus: false, scroll: !!(d0 && start !== 'bestellung') });
  var serverFehler = $('mbf-serverfehler'); if (serverFehler) try { serverFehler.focus(); } catch (x) {}
  if (!d0) { var e0 = $('mbf-entwurf'); if (e0) e0.textContent = ''; }
})();
